import { render, staticRenderFns } from "./verifications.vue?vue&type=template&id=5e147dd2&scoped=true"
import script from "./verifications.vue?vue&type=script&lang=js"
export * from "./verifications.vue?vue&type=script&lang=js"
import style0 from "./verifications.vue?vue&type=style&index=0&id=5e147dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e147dd2",
  null
  
)

export default component.exports